import { getPlaceholder } from '@helpers/placeholder';
import SvgUpload from '@img/icons/upload.svg';
import * as React from 'react';
import S from '../../UmbracoForm.styles';
const MultipleFileUpload = React.forwardRef(({ id, dirty, error, field, ...otherProps }, ref) => {
    const [fileNames, setFileNames] = React.useState([]);
    const placeholder = field.settings?.placeholder ?? field.placeholder ?? undefined;
    return (React.createElement(S.Field, { "data-dirty": dirty, "data-valid": dirty && !error, "data-invalid": dirty && !!error, style: { '--inputHeight': '36px' } },
        React.createElement(S.HiddenInput, { ref: ref, id: id ?? field.alias, multiple: true, type: "file", ...otherProps, onChange: (event) => {
                const files = event.target.files ?? [];
                if (files.length === 0) {
                    setFileNames([]);
                }
                setFileNames(Array.from(files).map((x) => x.name));
            } }),
        React.createElement(S.FileUploadLabelContainer, null,
            React.createElement(S.ControlLabel, { tabIndex: -1, htmlFor: id ?? field.alias, "data-hover-styles": true },
                React.createElement(SvgUpload, null),
                field.caption),
            (fileNames || !!placeholder) && (React.createElement(S.FileNameContent, null, fileNames.length > 0 ? fileNames.map((x) => x).join(',') : getPlaceholder(field)))),
        field.helpText && React.createElement(S.HelpText, null, field.helpText),
        error && React.createElement(S.Error, null, error.message)));
});
MultipleFileUpload.displayName = 'MultipleFileUpload';
export default MultipleFileUpload;
